import { useCallback, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { IFilters } from 'types/configurations'

import { InputSearch } from 'components/InputSearch'
import { InputSelect } from 'components/InputSelect'
import ActionStatus from 'components/ActionStatus'
import {
    CleanFilters,
    FilterButton,
    FilterContainer,
    FilterText,
    LineUser,
    CreateButton,
    Subtitle,
    Title,
    UsersContainer,
    UsersFilters
} from 'pages/Configurations/Users/styles'
import { Dispatch } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { UserAction, UserReducer, User, userProfiles, TypeTableColums } from 'types/user'
import UserActions from 'actions/User'
import { titleTableUsers } from 'components/SharedTable/models'
import { LocationAction, LocationReducer } from 'types/location'
import { SectorReducer } from 'types/sector'

import LocationActions from 'actions/Location'
import { isEmail } from 'helper/regex'
import SharedTable from 'components/SharedTable'
import { GetComponentActiveInactive } from './Children/ActivOrNotColum'
import { GetUnitySectors, IListOfSectorAndLocations } from './Children/UnitySectorColum'
import { AuthenticationReducer } from 'types/autentication'

import { disabledExport, ExportButton } from 'pages/Report/styles'
import { AiOutlineDownload } from 'react-icons/ai'


export interface IUsersColumns {
    link: string,
    u_user: string,
    u_location_and_sector: JSX.Element,
    u_profile: string,
    u_location: string,
    u_sector: string,
    'u_user.email': string
    u_active: JSX.Element | string

}
const ConfigurationsUsers = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [actionStatus, setActionStatus] = useState<boolean>(false)
    const [selectedFilters, setSelectedFilters] = useState<IFilters>({})
    const userDispatch: Dispatch<UserAction> = useDispatch<Dispatch<UserAction>>()
    
    const locationDispatch: Dispatch<LocationAction> = useDispatch<Dispatch<LocationAction>>()
    const { control, register, watch, handleSubmit, getValues, setValue } = useForm()
    
    
    const userSelector: UserReducer = useSelector( (state: RootReducerState) => state.userReducers)
    const locationSelector: LocationReducer = useSelector( (state: RootReducerState) => state.locationReducers )
    const sectorSelector: SectorReducer = useSelector((state: RootReducerState) => state.sectorReducers )
    const authenticationSelector: AuthenticationReducer = useSelector((state: RootReducerState) => state.authenticationReducers)
    
    const [paginationItensByPage, setPaginationItensByPage] = useState<number>(10)
    
    const profileValue: string = watch('profile')
    const unityValue: string = watch('unity')
    const sectorValue: string = watch('sector')
    const searchValue: string = watch('search')

    const [userFilter, setUserFilter] = useState<User>(null)
    const [userExport, setUserExport] = useState<User>(null)
    const [userOrder, setUserOrder] = useState<any>({ field: 'u_notifica_users', order: 'ORDERBY' })
    const [userTableCurrentPage, setUserTableCurrentPage] = useState<number>(0)
    const [showCleanFilter, setShowCleanFilter] = useState<boolean>(false)
    const [userSectors, setUserSectors] = useState<any[]>([])
    const [showToolTipAlertExport, setShowToolTipAlertExport] = useState(-1)

    const handleGetBodyForCsv = async () => {
        // Verifica se há dados para exportar
        if (!userSelector.usersListDataTable || userSelector.usersListDataTable.length === 0) {
            setShowToolTipAlertExport(0);
            setTimeout(() => {
                setShowToolTipAlertExport(null);
            }, 4000);
            return;
        }

        try {
            await UserActions.getUsersToDownload(userExport);
            window.scrollTo(0, 0);
            setShowToolTipAlertExport(1);
            setTimeout(() => {
                setShowToolTipAlertExport(null);
            }, 4000);
        } catch (error) {
            console.error("Erro ao baixar usuários:", error);
            setShowToolTipAlertExport(0);
        }
    };

    // Verifica se o botão de exportar deve estar desabilitado
    const isExportDisabled = useMemo(() => {
        return !userSelector.usersListDataTable || userSelector.usersListDataTable.length === 0;
    }, [userSelector.usersListDataTable]);

    const exportedCsvStatus = useMemo(() => {  
        return showToolTipAlertExport
    }, [showToolTipAlertExport])


    useEffect(() => {
        handleCleanFilters()
        UserActions.getPaginatedUsersWithLocationsAndSectors(userDispatch)
        LocationActions.getAllLocations(locationDispatch)
        if (location && location.state && location.state.saveUser) {
            window.scrollTo(0, 0)
            setActionStatus(true)
            setTimeout(() => {
                setActionStatus(false)
            }, 3000)
        }
    }, [authenticationSelector?.dataJwt])


    const profileMemoSelect = useMemo(() => (
        userProfiles?.map((u) => ({
            value: u.id, label: u.title
        })).sort((o1, o2) => o1.label.localeCompare(o2.label))
    ), [authenticationSelector?.dataJwt])

    const locationMemoSelect = useMemo(() => (
    locationSelector.locationsList?.map((l) => ({
        value: l.sys_id,
        label: l.name
    }))
        .sort((o1, o2) =>
        o1.label.localeCompare(o2.label)
        )
    ), [authenticationSelector?.dataJwt])

    const onChangeProfile = useCallback((profileSelected: string) => {  
        setValue('profile', profileSelected)
    }, [profileValue])

    const onChangeLocation = useCallback((value: string) => {
        if (!value) {
            setValue('unity', 'Unidade')
        } else {
            const location = locationSelector.locationsList?.find((l) => l.sys_id === value)
            setValue('unity', value)

            const sectorsLocations = sectorSelector.sectorsGroupedByLocationId[location?.sys_id]?.sort((a, b) => a.u_name.localeCompare(b.u_name))

            let sectors = sectorsLocations?.map((l) => ({
                value: l.sys_id,
                label: l.u_name
            }))
                .sort((o1, o2) =>
                    o1.label.localeCompare(o2.label)
                )


            setUserSectors(sectors)
        }

    }, [unityValue])

    const onChangeSector = useCallback((value:string) => {
        if (!value) {
            setValue('sector', 'Setor')
        } else {
            setValue('sector', value)
        }
    }, [sectorValue])


    const handleNewUser = () => {
        UserActions.clearCurrentUser(userDispatch)
        navigate('novo-usuario')
    }

    const handleFilterWithSearch = () => {
        const searchParams = getValues('search')?.toLowerCase()
        if (searchParams === '') {
            setSelectedFilters({
                profile: selectedFilters.profile,
                unity: selectedFilters.unity,
                sector: selectedFilters.sector,
                ...{}
            })
        }
        if (searchParams === undefined) {
            return
        }
    }

    const handleFilterTable = (data: any) => {
        const isDefaultFilter =
            data?.profile === 'Perfil' &&
            data?.unity === 'Unidade' &&
            data?.sector === 'Setor';

        
        if (isDefaultFilter) {
            setSelectedFilters({});
            return;
        }
       
         setSelectedFilters(data);

    }

    const handleCleanFilters = () => {
        setShowCleanFilter(false)
        setValue('profile', '')
        setValue('unity', '')
        setValue('sector', '')
        setValue('search', '')
        setUserFilter(null)
        setUserExport(null)
        UserActions.getPaginatedUsersWithLocationsAndSectors(userDispatch)
    }

    const handleCleanInputSearch = () => {
        setSelectedFilters({
            profile: selectedFilters.profile,
            unity: selectedFilters.unity,
            sector: selectedFilters.sector
        })
        setValue('search', undefined)
    }

    const filterObjc = {
        perfil: watch('perfil') !== 'Perfil' ? watch('perfil') : undefined,
        unity: watch('unity') !== 'Unidade' ? watch('unity') : undefined,
        sector: watch('sector') !== 'Setor' ? watch('sector') : undefined,
        searchParams: getValues('search')?.toLowerCase() || undefined
    }

    /**
     * Adiciona o compoenente Ativo/Inativo para listagem principal
     * @param sectorList
     */
    const renderComponentActiveInactive = (usersListDataTable: TypeTableColums[]): IUsersColumns[] => {       

        return usersListDataTable?.map((user, idx) => {
            const userComponent: IUsersColumns = { ...user, u_location_and_sector: <></> }
            userComponent['u_active'] = <GetComponentActiveInactive isActive={user.u_active} />
            userComponent['u_location_and_sector'] = <GetUnitySectors elements={user.listOfSectorAndLocations} index={idx} />

            return userComponent
        }
        )
    }

    /**
     * Dispara a requisição para listar os usuários de acordo com o offsset de paginação,
     * aqui o offset é chamado via callback quando algum botão na paginação é clicado
     * Esse offset é enviado para o ServiceNow via webservice junto com o numero de itens por pagina
     * O Action pega o retorno desse webservice e
     * grava no Redux usando a propriedade 'locationSectorList' do LocationReducer
     * @param offset - Numero de retorno ao clicar em um item de paginação
     */
    const handlerPaginationTableLocationSector = (offset: number) => {
        setUserTableCurrentPage(offset)
        UserActions.getPaginatedUsersWithLocationsAndSectors(
            userDispatch,
            `${offset}`,
            `${paginationItensByPage}`,
            userFilter,
            userOrder
        )
    }

    const handlerTableOrderByField = (orderFieldSelected: any) => {
        setUserTableCurrentPage(0)
        
        console.log('=== orderFieldSelected', orderFieldSelected)
        // Mapeamento de campos para ordenação
        const fieldMapping: { [key: string]: string } = {
            'u_user': 'u_notifica_users',
            'u_user.email': 'u_notifica_users.u_user.email',
            'u_active': 'u_active'
        }
        
        // Aplica o mapeamento se existir, senão usa o campo original
        const mappedField = fieldMapping[orderFieldSelected.field] || orderFieldSelected.field
        
        const mappedOrder = {
            field: mappedField,
            order: orderFieldSelected.order
        }
        
        setUserOrder(mappedOrder)
        UserActions.getPaginatedUsersWithLocationsAndSectors(
            userDispatch,
            `0`,
            `${paginationItensByPage}`,
            userFilter,
            mappedOrder
        )
    }

    useEffect(() => {
        UserActions.getPaginatedUsersWithLocationsAndSectors(
            userDispatch,
            `0`,
            `${paginationItensByPage}`,
            userFilter,
            userOrder
        )
    }, [userFilter])


    const handlerFilterTableUsers = () => {
        const paramFilter: any = {};
        const paramExport: any = {};

        if (profileValue && profileValue !== 'Perfil') {
                paramFilter['u_notifica_users.u_profile'] = profileValue;
                paramExport['u_notifica_users.u_profile'] = profileValue;
        }

        if (unityValue && unityValue !== 'Unidade') {
            paramFilter.u_location = unityValue;
            paramExport.u_location = unityValue;
        }

        if (sectorValue && sectorValue !== 'Setor') {
            paramFilter.u_location_sector = sectorValue;
        }

        if (searchValue && searchValue.trim() !== '') {
            if (isEmail(searchValue)) {
                paramFilter['u_notifica_users.u_user.email'] = searchValue;
            } else {
                paramFilter[`u_notifica_users.u_userSTARTSWITH${searchValue}`] = '';
            }
        }

        setShowCleanFilter(Object.keys(paramFilter).length > 0);
        setUserFilter(paramFilter);
        setUserExport(paramExport);
    };

    return (
        <UsersContainer>
            <CreateButton id={'bt-create-user'} className={actionStatus ? 'mb-6' : 'mb-[40px]'} onClick={handleNewUser}>
                + Criar novo usuário
            </CreateButton>
   
            <div className="pb-3" data-testid="test-tooltip-alert">
                {exportedCsvStatus && exportedCsvStatus >= 0 && (
                    <ActionStatus text={
                        exportedCsvStatus > 0 ? 
                        "Relatório exportado com sucesso!" : 
                        "Não há dados para exportar. Aplique filtros primeiro."
                    }
                        status={exportedCsvStatus} />

                )}
                {actionStatus && (
                    <ActionStatus
                        text={
                            location &&
                                location.state &&
                                location.state.messageSuccess
                                ? location.state.messageSuccess
                                : ''
                        }
                        status={1}
                    />
                )}
            </div>
            

            <LineUser />

            <Title>Lista de usuários</Title>
            <Subtitle>
                Confira abaixo a lista de todos os usuários cadastrados, e caso
                deseje verificar dados específicos, faça a busca pelos filtros.
            </Subtitle>

            <UsersFilters>
                <FilterText>Filtros</FilterText>
                <FilterContainer onSubmit={handleSubmit(handleFilterTable)}>
                    <div className="flex gap-2">
                        <InputSelect
                            searchPlaceHolder="Buscar"                            
                            shouldHaveSearch={true}
                            styleContainer={`w-[200px] `}
                            styleBoxOptions="w-[500px] top-[55px]"
                            unitText="Unidade"
                            name="unity"
                            control={control}
                            data={locationMemoSelect}
                            placeholder="Unidade"
                            onChange={onChangeLocation}
                        />

                        <InputSelect
                            searchPlaceHolder="Buscar"
                            shouldHaveSearch={true}
                            styleContainer={`w-[200px] `}
                            styleBoxOptions="w-[360px] top-[55px]"
                            unitText="Setor"
                            name="sector"
                            control={control}
                            data={userSectors}
                            placeholder="Setor"
                            onChange={onChangeSector}
                        />

                        <InputSelect
                            searchPlaceHolder="Buscar"
                            shouldHaveSearch={true}
                            styleContainer={`w-[200px] `}
                            styleBoxOptions="w-[360px] top-[55px]"
                            name="profile"
                            control={control}
                            data={profileMemoSelect}
                            placeholder="Perfil"
                            onChange={onChangeProfile}
                        />
                        <div>
                            <FilterButton onClick={() => handlerFilterTableUsers()} >
                                Filtrar
                            </FilterButton>
                        </div>
                    </div>

                    <InputSearch
                        handleCleanInputSearch={handleCleanInputSearch}
                        searchValue={filterObjc?.searchParams}
                        onBlur={handleFilterWithSearch}
                        name="search"
                        register={register}
                        className="w-full"
                        placeholder="Buscar usuário ou e-mail"
                    />
                    <div>
                        
                     <ExportButton data-testid="test-csv-link"
                            type='button'
                            onClick={handleGetBodyForCsv}
                            className={`p-2 ${isExportDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:brightness-90'}`}
                            title={isExportDisabled ? 
                                "Não há dados para exportar. Aplique filtros primeiro." : 
                                "Você pode exportar o relatório completo ou selecionar o filtro de Unidade para exportar apenas os dados dessa unidade."
                            }
                            disabled={isExportDisabled}>
                            <AiOutlineDownload size={20} />
                            Exportar relatório
                        </ExportButton>
                    </div>
                </FilterContainer>
                {showCleanFilter && (
                    <CleanFilters onClick={handleCleanFilters}>
                        Limpar Filtros
                    </CleanFilters>
                )}
            </UsersFilters>

            <SharedTable<IUsersColumns>
                titleTable={titleTableUsers}
                selectedFilters={selectedFilters}
                tableData={renderComponentActiveInactive(
                    userSelector.usersListDataTable
                )}
                paginationTotal={userSelector.userAllCount}
                paginationItensByPage={paginationItensByPage}
                paginationNumberSelectedPage={
                    handlerPaginationTableLocationSector
                }
                orderCollumnSelected={
                    handlerTableOrderByField
                }
                paginationCurrentPage={userTableCurrentPage}
            />
        </UsersContainer>
    )
}

export { ConfigurationsUsers }
